import { useAppSelector } from 'appState/store'
import styled from 'styled-components'
// components
// types
import { TakeOverTypeEnum } from '@outbound-ai/softphone'
import { MuteUnmuteAudio } from 'components/Buttons/MuteUnmuteAudio'
import { formatPhoneNumber } from 'utils'

interface IProps {
  isMuted: boolean
  providerName: string
  providerPhoneNumber?: string
  onIconClick: () => void
}
const ChatHeader = ({ isMuted, providerName, providerPhoneNumber, onIconClick }: IProps) => {
  const { elapsedTime, takeOver, isConnected } = useAppSelector((state) => state.calls.talkToPayorRepLiveCall)

  // variables
  const showMuteUnmuteAudio = isConnected && ![TakeOverTypeEnum.dialed].includes(takeOver.type)

  return (
    <Section>
      <section className="left">
        <span>
          <strong>{providerName}</strong>
        </span>
        {providerPhoneNumber && providerPhoneNumber !== providerName && <span>{formatPhoneNumber(providerPhoneNumber)}</span>}
      </section>
      <section className="right">
        {showMuteUnmuteAudio && <MuteUnmuteAudio isMutedAudio={isMuted} toggleIsMuted={onIconClick} />}
        <span className="elapsed-time">{elapsedTime}</span>
      </section>
    </Section>
  )
}

const Section = styled.section`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-left: ${({ theme }) => theme.util.pixelToRem(18)};

  .left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    span:first-child {
      font-weight: ${({ theme }) => theme.fontWeight.bold};
      ${({ theme }) => theme.typography.h5.normal};
      color: ${({ theme }) => theme.colors.primary.darker};
    }
    span:last-child {
      font-weight: ${({ theme }) => theme.fontWeight.normal};
      ${({ theme }) => theme.typography.s.normal};
      color: ${({ theme }) => theme.colors.primary.darker};
    }
  }
  .right {
    display: flex;
    align-items: center;

    span.audio-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: ${({ theme }) => theme.util.pixelToRem(45)};
      height: ${({ theme }) => theme.util.pixelToRem(45)};
      border: 1px solid ${({ theme }) => theme.colors.grey.lighter};
      border-radius: 0.75rem;
      padding: ${({ theme }) => `${theme.spacing.s} ${theme.spacing.xs}`};
      margin-right: 0.75rem;

      svg {
        width: ${({ theme }) => theme.spacing.m};
        height: ${({ theme }) => theme.spacing.s};
      }

      &:hover {
        background-color: ${({ theme }) => theme.colors.grey.lighter};
        cursor: pointer;
      }
    }

    span.elapsed-time {
      width: 7rem;
      display: flex;
      align-items: center;
      height: 100%;
      background-color: ${({ theme }) => theme.colors.grey.lighter};
      padding: ${({ theme }) => `${theme.util.pixelToRem(18)} ${theme.util.pixelToRem(22)}`};
      color: ${({ theme }) => theme.colors.grey.darker};
      font-weight: ${({ theme }) => theme.fontWeight.bold};
    }
  }
`

export { ChatHeader }
